import moment from "moment";

const MDY = "MM/DD/YY";
const MDY4 = "MM/DD/YYYY";
const MDY4FILE = "MM_DD_YYYY";
const MDYHMA = "M/D/YY h:mmA";
const MDYHM24 = "MM/DD/YYYY HH:mm";
const MDYHMS = "MM/DD/YYYY hh:mm:ss";
const YMD = "YYYY-MM-DD";
const YMDHM = "YYYY-MM-DD HH:mm";
const YMDHMS = "YYYY-MM-DD HH:mm:ss";

const currentDate = () => {
  const date = new Date();
  return `${date.getMonth() + 1}-${date.getDate()}-${date.getFullYear()}`;
};

const momentFromString = function (date, fmt = null) {
  if (fmt) {
    return moment(date, fmt, true);
  }
  if (date) {
    return moment(date);
  }
  return null;
};

const VALID_DATE_FORMAT_LIST = [
  MDY4,
  "M/D/YY",
  "MM/D/YY",
  MDY,
  "MM/D/YYYY",
  "M/D/YYYY",
  YMD,
];

const verifyDate = (s) => {
  if (!s) return null;
  const test = moment(s, VALID_DATE_FORMAT_LIST);
  return test.isValid() ? test : null;
};

// A picked calendar day as a UTC-clock instant. The ship-schedule queries read only the date part of the ISO value,
// so the day must be built from its year/month/day - shifting by TODAY's timezone offset lands an hour into the next
// day once a daylight-saving change falls between today and the picked date.
const utcDay = (d, hours, minutes, seconds) => {
  const day = verifyDate(d);
  return day ? new Date(Date.UTC(day.year(), day.month(), day.date(), hours, minutes, seconds)) : null;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  currentDate,
  MDY,
  MDY4,
  MDYHMA,
  MDYHM24,
  verifyDate,
  YMD,
  YMDHM,

  utcDayStart(d) {
    return utcDay(d, 0, 0, 0);
  },

  utcDayEnd(d) {
    return utcDay(d, 23, 59, 59);
  },

  addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  },

  convertUTCDateToLocalDate(date) {
    var newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);

    var offset = date.getTimezoneOffset() / 60;
    var hours = date.getHours();

    newDate.setHours(hours - offset);

    return newDate;
  },

  dateTimeFormat(dateTime, fmt = null) {
    if (!fmt) fmt = MDYHMS;
    if (dateTime) {
      return moment(dateTime).format(fmt);
    }
    return dateTime;
  },

  dateTimeFormatUTC(dateTime, fmt = null) {
    if (!fmt) fmt = MDYHMS;
    if (dateTime) {
      return moment.utc(dateTime).local().format(fmt);
    }
    return dateTime;
  },

  // formatDateForServer(date, fmt) {
  //   if (date === "") return null;
  //
  //   if (typeof date === "string") {
  //     if (typeof date === "string") {
  //       date = new Date(date);
  //     }
  //     const year = date.getFullYear();
  //     const month = String(date.getMonth() + 1).padStart(2, "0");
  //     const day = String(date.getDate()).padStart(2, "0");
  //     let formattedDate = `${year}-${month}-${day}`;
  //     return formattedDate;
  //   }
  // },

  formatDateForServer(date, fmt) {
    if (date === "") return null;
    if (date) {
      if (moment.isMoment(date)) return date.format(YMD);
      return moment(date, fmt).format(YMD);
    }
    return date;
  },

  formatDateForServerSafari(date) {
    //safari breaks on (moment(date, fmt).format(YMD), this function doesn't have to just be used here,
    //but I did not want to fully replace formatDateForServer without testing it across the site.
    const parts = date.split("-");
    if (parts.length !== 3) {
      console.error("Invalid date format.");
      return null;
      //makes sure you have 3 seperate parts for mdy
    }
    const month = parts[0].padStart(2, "0");
    const day = parts[1].padStart(2, "0");
    const year = parts[2];
    //pads single digit values with leading 0

    if (isNaN(month) || isNaN(day) || isNaN(year)) {
      //makes sure you are passing numeric values
      console.error("Invalid date values");
      return null;
    }
    //console.log(year, month, day);
    return `${year}-${month}-${day}`;
  },

  formatDateTimeForServer(dateTime) {
    if (dateTime === "") return null;
    if (dateTime) {
      if (moment.isMoment(dateTime)) return dateTime.format(YMDHMS);
      return moment(dateTime).format(YMDHMS);
    }
    return dateTime;
  },

  formatDateToShortDate(date, fmt = null) {
    if (date) {
      if (moment.isMoment(date)) {
        return date.format(MDY4);
      } else if (fmt === null) {
        return moment(date).format(MDY4);
      } else {
        return moment(date, fmt, true).format(MDY4);
      }
    }
    return date;
  },

  getDateStringForReportName() {
    return moment().format(MDY4FILE);
  },

  getLookbackByDays(lookback) {
    let date = new Date();
    date = new Date(date.setDate(date.getDate() - lookback));
    return `${date.getMonth() + 1}-${date.getDate()}-${date.getFullYear()}`;
  },

  getLookbackByYears(lookback) {
    let date = new Date();
    date = new Date(date.setFullYear(date.getFullYear() - lookback));
    return `${date.getMonth() + 1}-${date.getDate()}-${date.getFullYear()}`;
  },

  getMomentFromString(date, fmt) {
    return momentFromString(date, fmt);
  },

  getSelectedDate(date, fmt = null) {
    if (date) {
      return fmt ? moment(date).format(fmt) : moment(date);
    }
    return null;
  },

  getTimeStringFromMoment(m) {
    if (!m) return "";
    return m.format("hh:mm A");
  },

  isDateValid(dateString) {
    if (!dateString) {
      return false;
    }
    if (!moment(dateString, "MM/DD/YYYY", true).isValid()) {
      return false;
    }
    return true;
  },

  momentFromString: momentFromString,

  monthDayAndYear(dateTime) {
    if (dateTime) {
      return moment(dateTime).format(MDY4);
    }
    return dateTime;
  },

  monthDayAndYearUTC(dateTime) {
    if (dateTime) {
      return moment.utc(dateTime).local().format(MDY4);
    }
    return dateTime;
  },

  parseDatePickerDate(s, fmt = YMD) {
    const validated = verifyDate(s);
    if (validated) {
      return validated.format(fmt);
    } else {
      return s;
    }
  },

  shortDateTimeFormat(dateTime) {
    if (dateTime) return moment(dateTime).format(MDYHM24);
    return dateTime;
  },

  toDateString(d, fmt = null) {
    if (!d) return "";
    return momentFromString(d, fmt).format("ddd, MM/DD/YY");
  },

  toLongDateString(d, fmt = null) {
    //const formatStyle = moment(d, "YYYY/MM/DD");
    if (!d) return "";
    return momentFromString(d, fmt).format("MM/DD/YYYY");
  },

  toLongDateWithHours(input) {
    const date = new Date(input);
    if (isNaN(date.getTime())) {
      return "";
    }

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours24 = date.getHours();
    const hours12 = hours24 % 12 || 12; // Convert to 12-hour format
    const hours = String(hours12).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours24 >= 12 ? "pm" : "am";

    return `${month}/${day}/${year} ${hours}:${minutes} ${ampm}`;
  },

  toMDYDateString(d, fmt = null) {
    if (!d) return "";
    return momentFromString(d, fmt).format("MM-DD-YYYY");
  },

  toShortDateString(d, fmt = null) {
    if (!d) return "";
    return momentFromString(d, fmt).format("DD-MMM-YY");
  }
};
